import { html } from '@microsoft/fast-element';
import { foundationDialogTemplate } from '../dialog';
export const foundationModalTemplate = html `
  ${foundationDialogTemplate}
`;
